export default __webpack_public_path__ + "static/media/icon-lg-trashcan.b93cafcb.svg";